var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbedSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 415,
    height: 180,
    rx: 3,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13a3 3 0 013-3h409a3 3 0 013 3v16H10V13z",
    fill: "#FAFBFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 47,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 9,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 47,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#B9BEC7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 47,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 47,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 49,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 89,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 129,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 169,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 87,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 87,
    width: 9,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 87,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#5595EF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 87,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 87,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 127,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 127,
    width: 9,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 127,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#FBCC43"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 127,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 127,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 167,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 167,
    width: 9,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 167,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#7DC560"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 167,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 167,
    width: 41,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#E9EBF0",
    d: "M10 69h415v1H10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9EBF0",
    d: "M10 29h415v1H10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#E9EBF0",
    d: "M39 10h1v180h-1zM116 10h1v180h-1zM193 10h1v180h-1zM270 10h1v180h-1zM347 10h1v180h-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#E9EBF0",
    d: "M10 109h415v1H10zM10 149h415v1H10z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 435,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedSheet);
export default __webpack_public_path__ + "static/media/embed-sheet.8575936b.svg";
export { ForwardRef as ReactComponent };